import {
  DeleteTwoTone,
  OrderedListOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons'
import {
  Avatar,
  Button,
  Comment,
  Empty,
  Pagination,
  Popconfirm,
  Space,
  Tabs,
  message,
} from 'antd'
import { find } from 'lodash-es'
import { inject, observer } from 'mobx-react'
import React, { memo, useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import AppPageHeader from '../../components/AppPageHeader'
import { blue } from '../../color'
import AccessControlAction from '../../components/AccessControlAction/AccessControlAction'
import AddUserForm from '../../components/AddUserForm/AddUserForm'
import {
  TextWrap,
  trimOverlengthString,
} from '../../components/Common/CellText'
import TableComponent from '../../components/Common/TableComponent'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import PageTitle from '../../components/PageTitle'
import UserAccountEditForm from '../../components/UserAccountEditForm'
import { apiUrl } from '../../config'
import { ACL_ACTION_TYPE } from '../../constants'
import DashboardLayout from '../../layouts/DashboardLayout/DashboardLayout'
import authenticationStore from '../../stores/authenticationStore'
import positionStore from '../../stores/positionStore'
import roleStore from '../../stores/roleStore'
import { MODAL_MODE } from '../../ui_constants'
import {
  ListDepartmentContent,
  TabsDepartmentWrapper,
} from '../Contacts/ListDepartment/ListDepartmentStyled'
import {
  ButtonItem,
  ButtonItemWrapper,
} from '../UserGroupPage/ListUserGroup/ListUserGroupStyled'
import CreateDepartmentModal from './CreateDepartmentModal'
import SortDepartmentModal from './SortDepartmentModal/SortDepartmentModal'
import './index.css'
import {
  AddCircleOutlineIcon,
  Pen2OutlineIcon,
  TrashBin2OutlineIcon,
  UserPlusBrokenIcon,
} from '../../components/AppIcon'
import UserCard from '../../components/UserCard/UserCard'
import { AppTablePagination } from '../../components/AppTable/AppTablePagination'

const { TabPane } = Tabs

const ManageDepartmentPage = props => {
  const { departmentStore, userStore, loadingAnimationStore } = props

  const { departmentList } = departmentStore

  const {
    userOfDepartmentListTotalCount,
    userOfDepartmentListPageIndex,
    userOfDepartmentListPageSize,
  } = userStore

  const [userOfDepartmentData, setUserOfDepartmentData] = useState([])
  const [currentDepartment, setCurrentDepartment] = useState()
  const [checkUpdate, setCheckUpdate] = useState(false)
  const [checkDel, setCheckDel] = useState(false)

  //create/edit department modal
  const [
    isVisibleCreateDepartmentModal,
    setIsVisibleCreateDepartmentModal,
  ] = useState(false)
  const [mode, setMode] = useState(null)

  //add user
  const [isVisibleAddUser, setIsVisibleAddUser] = useState(false)
  //edit user
  const [isVisibleEditUser, setIsVisibleEditUser] = useState(false)
  //sort department
  const [
    isVisibleSortDepartmentModal,
    setIsVisibleSortDepartmentModal,
  ] = useState(false)

  const tableColumn = [
    {
      title: 'Thông tin',
      width: 248,
      render: record => (
        <Comment
          author={
            <span style={{ textTransform: 'capitalize' }}>
              {record.name_lowercase}
            </span>
          }
          avatar={
            <Avatar
              style={{ backgroundColor: '#1890ff' }}
              src={
                record.imageId && `${apiUrl}/api/v1/images/${record.imageId}`
              }>
              {record?.name_uppercase.split('')[0].toString().toUpperCase()}
            </Avatar>
          }
        />
      ),
    },
    {
      title: 'ID',
      width: 100,
      render: record => record?.username,
    },
    // {
    //   title: 'Phân quyền',
    //   width: 160,
    //   render: record => record?.acl_group?.name ?? 'Mặc định',
    // },
    {
      title: 'Chức vụ',
      render: record => (record.position ? record?.position.name : 'Chưa rõ'),
    },
    {
      fixed: 'right',
      align: 'center',
      title: <ButtonItemWrapper></ButtonItemWrapper>,
      render: record => <></>,
    },
  ]

  const rowClassName = record => (record.status ? '' : 'disabled-row-table')

  const handleViewUserInfo = useCallback(
    userInfo => {
      userStore.setSelectedUser(userInfo)
      setIsVisibleEditUser(true)
    },
    [departmentStore, loadingAnimationStore, userStore]
  )

  const onChangeTabDepartment = async key => {
    try {
      loadingAnimationStore.setTableLoading(true)

      userStore.setFilter('userOfDepartmentListByDepartmentCode', key)
      userStore.setFilter('userOfDepartmentListPageIndex', 0)

      await loadUserList()

      setCurrentDepartment(find(departmentList, { code: key }))
    } catch (e) {
      message.error(e.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.setTableLoading(false)
    }
  }

  const loadUserList = async () => {
    let response = await userStore.getUserListByDepartment()
    setUserOfDepartmentData(response.data)
  }

  const onChangePagination = async (pageIndex, pageSize) => {
    try {
      loadingAnimationStore.setTableLoading(true)

      userStore.setFilter('userOfDepartmentListPageIndex', pageIndex - 1)
      userStore.setFilter('userOfDepartmentListPageSize', pageSize)

      let response = await userStore.getUserListByDepartment()
      setUserOfDepartmentData(response.data)
    } catch (e) {
      message.warning('Lỗi lấy thông tin người dùng trong phòng ban!')
    } finally {
      loadingAnimationStore.setTableLoading(false)
    }
  }

  const handleDelete = async () => {
    if (userOfDepartmentListTotalCount === 0) {
      try {
        loadingAnimationStore.showSpinner(true)

        await departmentStore.delete(currentDepartment.code)

        await departmentStore.getAllDepartmentList(
          userStore.companyCodeCurrent ||
            authenticationStore.currentCompanyCode()
        )
        // if (departmentList.length > 0) {
        //   onChangeTabDepartment(departmentList[0].code)
        // }
        setCheckDel(true)
      } catch (e) {
        message.error(e.vi || 'Đã có sự cố xảy ra')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    } else {
      message.warning('Không thể xóa phòng ban đã có nhân viên')
    }
  }

  const showCreateDepartmentModal = () => {
    setIsVisibleCreateDepartmentModal(true)
    setMode(MODAL_MODE.CREATE)
  }

  const handleCloseCreateDepartmentModal = () => {
    setIsVisibleCreateDepartmentModal(false)
    setMode(null)
  }

  const showAddUser = () => {
    setIsVisibleAddUser(true)
  }

  const handleCancelAddUser = () => {
    setIsVisibleAddUser(false)
  }

  const handleCancelEditUser = () => {
    setIsVisibleEditUser(false)
  }

  const onRefreshListUser = () => {
    // console.log('onRefreshListUser')
    loadUserList()
  }

  const showSortDepartmentModal = () => {
    setIsVisibleSortDepartmentModal(true)
  }

  const handleCancelSortDepartmentModal = () => {
    setIsVisibleSortDepartmentModal(false)
  }

  const onRefreshListDepartment = async () => {
    loadingAnimationStore.showSpinner(true)
    await departmentStore.getAllDepartmentList(
      userStore.companyCodeCurrent || authenticationStore.currentCompanyCode()
    )
    loadingAnimationStore.showSpinner(false)
  }

  useEffect(() => {
    if (authenticationStore.currentUser) {
      loadingAnimationStore.showSpinner(true)

      Promise.all([
        departmentStore.getAllDepartmentList(
          userStore.companyCodeCurrent ||
            authenticationStore.currentCompanyCode()
        ),
        //for create user account
        positionStore.getPositionList(),
        roleStore.getRoles(),
      ])
        .then(async responses => {
          let firstDept = responses[0].data[0]
          setCurrentDepartment(firstDept)

          userStore.setFilter(
            'userOfDepartmentListByDepartmentCode',
            firstDept?.code
          )
          let response = await userStore.getUserListByDepartment()
          setUserOfDepartmentData(response.data)
        })
        .catch(e => {
          console.log(e)
          message.warning('Lỗi lấy thông tin phòng ban!').then()
        })
        .finally(() => {
          loadingAnimationStore.showSpinner(false)
        })
    }

    return () => {
      departmentStore.clearDepartmentList()
    }
  }, [
    authenticationStore.currentUser,
    userStore.companyCodeCurrent,
    checkUpdate,
    checkDel,
  ])

  // giống với cái useEffect ngay trên, nhưng không rõ tại sao viết,do cái useEffect này nên bị lấy sai data => tạm thời cmt
  // useEffect(() => {
  //   Promise.all([
  //     departmentStore.getAllDepartmentList(
  //       authenticationStore.currentCompanyCode()
  //     ),
  //     //for create user account
  //     positionStore.getPositionList(),
  //     roleStore.getRoles(),
  //   ])
  //     .then(async responses => {
  //       let firstDept = responses[0].data[0]
  //       setCurrentDepartment(firstDept)

  //       userStore.setFilter(
  //         'userOfDepartmentListByDepartmentCode',
  //         firstDept.code
  //       )
  //       let response = await userStore.getUserListByDepartment()
  //       setUserOfDepartmentData(response.data)
  //       setCheckDel(false)
  //     })
  //     .catch(e => {
  //       console.log(e)
  //       message.warning('Lỗi lấy thông tin phòng ban!').then()
  //     })
  //     .finally(() => {
  //       loadingAnimationStore.showSpinner(false)
  //     })
  // }, [checkUpdate || checkDel])

  return (
    <>
      <DashboardLayout>
        <Helmet>
          <title>Quản lý phòng ban</title>
        </Helmet>
        <AppPageHeader
          title="Quản lý phòng ban"
          addon={
            <>
              <AccessControlAction
                aclActionType={ACL_ACTION_TYPE.sort__QUAN_LY_PHONG_BAN}>
                <Button
                  className="custom-ant-button icon-btn"
                  icon={<OrderedListOutlined />}
                  onClick={showSortDepartmentModal}>
                  Sắp xếp
                </Button>
              </AccessControlAction>
              <AccessControlAction
                aclActionType={ACL_ACTION_TYPE.create__QUAN_LY_PHONG_BAN}>
                <Button
                  className="custom-ant-button icon-btn"
                  icon={
                    <AddCircleOutlineIcon
                      style={{ color: '#fff', width: 16, height: 16 }}
                    />
                  }
                  onClick={showCreateDepartmentModal}
                  type="primary">
                  Tạo phòng ban
                </Button>
              </AccessControlAction>
            </>
          }
        />

        <Tabs
          tabPosition={'left'}
          activeKey={currentDepartment?.code}
          onChange={onChangeTabDepartment}
          className="custom-ant-vertical-tabs">
          {departmentList.length !== 0 &&
            departmentList.map(department => {
              return (
                <TabPane
                  tab={
                    <>
                      <TextWrap>
                        {trimOverlengthString(department.name, 230)}
                      </TextWrap>
                    </>
                  }
                  key={department.code}>
                  <div className="custom-create-page-content-wrapper">
                    <AppPageHeader
                      title={department.name}
                      addon={
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0,
                          }}>
                          <AccessControlAction
                            aclActionType={
                              ACL_ACTION_TYPE.edit__QUAN_LY_PHONG_BAN
                            }>
                            <Button
                              title="Chỉnh sửa"
                              icon={
                                <Pen2OutlineIcon
                                  style={{ color: blue, width: 18, height: 18 }}
                                />
                              }
                              shape="circle"
                              type="text"
                              onClick={() => {
                                setIsVisibleCreateDepartmentModal(true)
                                setMode(MODAL_MODE.UPDATE)
                              }}
                            />
                          </AccessControlAction>

                          <AccessControlAction
                            aclActionType={
                              ACL_ACTION_TYPE.create_employee__QUAN_LY_PHONG_BAN
                            }>
                            <Button
                              title="Thêm nhân viên"
                              icon={
                                <UserPlusBrokenIcon
                                  style={{ color: blue, width: 18, height: 18 }}
                                />
                              }
                              shape="circle"
                              type="text"
                              onClick={() => showAddUser()}
                            />
                          </AccessControlAction>

                          <AccessControlAction
                            aclActionType={
                              ACL_ACTION_TYPE.delete__QUAN_LY_PHONG_BAN
                            }>
                            <Popconfirm
                              onConfirm={() => handleDelete()}
                              okText={'Đồng ý'}
                              cancelText={'Không'}
                              okType={'danger'}
                              icon={
                                <QuestionCircleOutlined
                                  style={{ color: 'red' }}
                                />
                              }
                              title={'Bạn có muốn xóa phòng ban này không?'}>
                              <Button
                                title="Xóa"
                                icon={
                                  <TrashBin2OutlineIcon
                                    style={{
                                      color: '#e74c3c',
                                      width: 18,
                                      height: 18,
                                    }}
                                  />
                                }
                                shape="circle"
                                type="text"
                                onClick={event => event.stopPropagation()}
                              />
                            </Popconfirm>
                          </AccessControlAction>
                        </div>
                      }
                    />

                    {userOfDepartmentData?.length ? (
                      <>
                        <div
                          style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
                            columnGap: 16,
                            rowGap: 24,
                          }}>
                          {userOfDepartmentData.map(user => (
                            <UserCard
                              key={user.code}
                              name={user.name_uppercase}
                              role={user?.position?.name}
                              email={user.email}
                              phone={user.phone}
                              avatar={
                                user?.imageId
                                  ? `${apiUrl}/api/v1/images/${user.imageId}`
                                  : null
                              }
                            />
                          ))}
                        </div>
                        <AppTablePagination
                          onChange={onChangePagination}
                          total={userOfDepartmentListTotalCount}
                          pageSize={userOfDepartmentListPageSize}
                          current={userOfDepartmentListPageIndex + 1}
                          showSizeChanger={false}
                          showLessItems
                          showQuickJumper={false}
                        />
                      </>
                    ) : (
                      <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description="Không có người dùng trong phòng ban này"
                      />
                    )}
                  </div>
                </TabPane>
              )
            })}
        </Tabs>
      </DashboardLayout>

      <CreateDepartmentModal
        setCheckUpdate={setCheckUpdate}
        isVisibleCreateDepartmentModal={isVisibleCreateDepartmentModal}
        mode={mode}
        handleCloseCreateDepartmentModal={handleCloseCreateDepartmentModal}
        currentDepartment={currentDepartment}
      />

      <AddUserForm
        currentDepartment={currentDepartment}
        modalVisible={isVisibleAddUser}
        onCancel={handleCancelAddUser}
        onRefreshListUser={onRefreshListUser}
      />

      <UserAccountEditForm
        modalVisible={isVisibleEditUser}
        onCancel={handleCancelEditUser}
        onRefreshListUser={onRefreshListUser}
      />

      <SortDepartmentModal
        departmentList={departmentList}
        isVisibleSortDepartmentModal={isVisibleSortDepartmentModal}
        onCancel={handleCancelSortDepartmentModal}
        handleCancelSortDepartmentModal={handleCancelSortDepartmentModal}
        onRefreshListDepartment={onRefreshListDepartment}
      />
    </>
  )
}

ManageDepartmentPage.propTypes = {}

export default memo(
  inject(
    'departmentStore',
    'userStore',
    'loadingAnimationStore'
  )(observer(ManageDepartmentPage))
)
